
import ErrorPage from "next/error"
import Head from "next/head"
import { getPageData, fetchAPI, getGlobalData, getEvents } from "../utils/api"
import Sections from "../components/sections"
import Seo from "../components/elements/seo"
import { useRouter } from "next/router"
const { buildInstagramHomepageSection } = require("../lib/instagram")
import MarketSchedulePreview from "../components/market-schedule/preview"
const { getMarketSchedule } = require("../lib/market-schedule")
//import Layout from "../components/layout"
import { getLocalizedPaths } from "../utils/localize"
import { PostHog } from "posthog-js"
//import { PostHog } from 'posthog-node'

// The file is called [[...slug]].js because we're using Next's
// optional catch all routes feature. See the related docs:
// https://nextjs.org/docs/routing/dynamic-routes#optional-catch-all-routes

const DynamicPage = ({ sections, metadata, preview, global, events, marketScheduleEvents, pageContext, error }) => {
    const router = useRouter()
    //console.log("Rendering page for slug %s (locale=%s, preview=%s)", pageContext?.slug, pageContext?.locale, preview)
    //console.log("Metadata: %o", metadata)
    //console.log("Sections: %o", sections)
    //console.log("Global: %o", global)
    //console.log("Events: %o", events)
    //console.log("Page context: %o", pageContext)
    //console.log("Error: %o", error)
    
    // Loading screen (only possible in preview mode)
    if (router.isFallback) {
        return <div className="container">Loading...</div>
    }

    // Check for an error
    if (error) {
        return <ErrorPage statusCode={error.status} message={error.message} />
    }

    // Check if the required data was provided
    if (!router.isFallback && !sections?.length) {
        return <ErrorPage statusCode={404} />
    }

    
    // Merge default site SEO settings with page specific SEO settings
    if (metadata?.metaImage === null) {
        delete metadata.metaImage
    }
    const metadataWithDefaults = {
        ...global.metadata,
        ...metadata,
    }

    const canonicalHref = 
        metadataWithDefaults.canonicalURL || 
        `https://${router.locale ? `${router.locale}.` : ''}${router.domain}${router.asPath}`
    //console.log("Canonical URL: %s", canonicalHref)


    return (
        
        // <Layout global={global} pageContext={pageContext}>
        <div className="">
            <Head>
                <link rel="canonical" href={canonicalHref} key="canonical"/>
            </Head>
        {/* Add meta tags for SEO*/}
        <Seo metadata={metadataWithDefaults} />
        {/* Display content sections */}
        <Sections sections={sections} events={events} preview={preview} key="_sections" />
        {pageContext?.slug === "index" ? <MarketSchedulePreview events={marketScheduleEvents} /> : null}
        </div>
        // </Layout>
    )
}

export async function getStaticPaths(context) {
    // Get all pages from Strapi
    const pages = await context.locales.reduce(
        async (currentPagesPromise, locale) => {
            const currentPages = await currentPagesPromise
            const localePages = await fetchAPI("/pages", {
                locale
            })
            return [...currentPages, ...localePages.data]
        },
        Promise.resolve([])
    )

    const paths = pages.map((page) => {
        const { slug, locale } = page.attributes
        // Decompose the slug that was saved in Strapi
        const slugArray = !slug ? [''] : slug.split("/").filter(Boolean)
    
        return {
            params: { slug: slugArray },
            // Specify the locale to render
            locale,
        }
    })
    // We'll pre-render only these paths at build time.
    // { fallback: 'blocking' } will server-render pages
    // on-demand if the path doesn't exist.
    return { paths, fallback: 'blocking' }
}

export async function getStaticProps(context) {
    const { params, locale, locales, defaultLocale, preview = null } = context
    const slugPath = (!params?.slug ? ['index'] : params.slug).join("/")

    if (params?.slug && params.slug[0].endsWith('.json')) {
        return { props: {}  }
    }
    
    //console.log("Generating page for slug %s (locale=%s, preview=%s)",(!params.slug ? 'index' : params.slug.join("/")), locale, preview)

    // fetch global properties
    const globalLocale = await getGlobalData(locale, preview)

    // fetch upcoming events
    const events = await getEvents(locale, preview)

    // Fetch pages. Include drafts if preview mode is on
    let p = {
        slug: (!params.slug ? ['index'] : params.slug).join("/"),
        locale,
        preview,
    }
    const pageData = await getPageData(p)

    if (!pageData) {
        // Giving the page no props will trigger a 404 page
        return { props: { } }
    }
    if (Object.keys(pageData).length === 0 ) {
        return { props: { } }
    }

    if (pageData.error) {
        return { props: { error: pageData.error} }
    }

    // We have the required page data, pass it to the page component
   // console.log("Page data: %o", pageData)
    const { sections, metadata, localizations, slug } = pageData
    const nextSections = Array.isArray(sections) ? [...sections] : []

    let marketScheduleEvents = []

    if (slugPath === "index") {
        const instagramSection = await buildInstagramHomepageSection()
        marketScheduleEvents = await getMarketSchedule(4, { context: "homepage:getStaticProps" })

        if (instagramSection) {
            nextSections.push(instagramSection)
        }
    }

    const pageContext = {
        locale,
        locales,
        defaultLocale,
        slug,
        localizations,
    }

   //  console.log('pageContext = %s', pageContext)
   //  console.log('sections = %s', sections)
   //  console.log('globalLocale = %s', globalLocale)
    const localizedPaths = getLocalizedPaths(pageContext)
   // console.log("Localized paths: %o", localizedPaths)
    return {
        props: {
            preview,
            sections: nextSections,
            metadata,
            global: globalLocale,
            events: events,
            marketScheduleEvents,
            pageContext: {
                ...pageContext,
                localizedPaths,
            },
        },
        // turn on ISR
        revalidate: 60,
    }

   // console.log("static props = %s", staticProps.props)
   // return staticProps
}

export default DynamicPage
